<template>
    <div style="height: 100%;overflow:hidden;">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
        // HelloWorld
    },
    created() {
        setTimeout(() => {
            // this.$GlobalStore.addModal('Contract', {work_calendar_idx : 9, completeAction : async () => {
            //
            //     }
            // });
            // this.$GlobalStore.addModal('MemberRegister', {id : '4287452155', mode : '0'})
        //     this.$GlobalStore.addModal('ContractAgreement')

        }, 1000)
        // if(location.pathname === '/view/reservation'){
        //     this.$GlobalStore.addModal('Survey');
        // }
    }
}
</script>
<style>
:root {
    --color-main : #6FBA2C;
    --color-border: #e2dfdf;
    --font-black-color:#231815;
}
</style>
<style scoped></style>
